module.exports = __webpack_public_path__ + "img/gallery-nft-07.7451eba2.png";